import React, { forwardRef, useEffect, useImperativeHandle } from 'react'
import { Controller, FormContext, useForm } from 'react-hook-form'
import { CompaignFormValues } from './CompaignModal'
import { CompaignType } from './fields/CompaignType'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { Box, Flex } from '@chakra-ui/core'
import { CampaignTypes } from './utils'
import { RootGroup } from './fields/RootGroup'
import { CampaignTags } from './fields/CampaignTags'

const defaultValues: CompaignFormValues = {
  campaign_type: CampaignTypes.POTENTIALS,
  root_group_id: null,
  tag_id: null,
}

export interface CompaignFormlRef {
  submit: () => void
}

interface CompaignFormProps {
  onClose: () => void
  onCreated: (data: any) => void
  campaign?: CompaignFormValues | null
}

export const CompaignForm = forwardRef<CompaignFormlRef, CompaignFormProps>(({ onClose, onCreated, campaign }, ref) => {
  const { rid } = useSelector((state: RootState) => state.config.config)

  const methods = useForm<CompaignFormValues>({
    defaultValues: campaign || defaultValues,
    mode: 'onChange',
  })

  const onSubmit = (data: CompaignFormValues) => {
    onCreated(data)
    onClose()
  }

  useImperativeHandle(ref, () => ({
    submit: () => {
      methods.handleSubmit(onSubmit)()
    },
    onClose,
  }))

  useEffect(() => {
    if (rid) {
      methods.setValue('retail_id', rid)
    }
  }, [rid, methods])

  return (
    <FormContext {...methods}>
      <Flex flexDir="column" style={{ rowGap: '10px' }}>
        <CompaignType />
        <RootGroup />
        <CampaignTags />
      </Flex>

      <Controller name="retail_id" control={methods.control} as={<Box display="none" />} />
    </FormContext>
  )
})
